class Preloader {
  constructor() {
    this.$spinner = $(".spinner-wrap");
    this.visibleClass = 'visible'
  }

  show () {
    this.$spinner.addClass(this.visibleClass)
  }

  hide () {
    this.$spinner.removeClass(this.visibleClass)
  }
}

$(document).on('ready turbolinks:load', function() {
  window.preloader = new Preloader()

  $(document).on("turbolinks:click", function() {
    preloader.show()
  });

  $(document).on("turbolinks:render", function() {
    preloader.hide()
  });
});
